import { useQuery } from '@tanstack/react-query'
import { listUsers } from './api/users'
import { DataTable } from '@shared/ui/DataTable'
import { ColumnDef } from '@tanstack/react-table'

export function UsersPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['users', { limit: 20, offset: 0 }],
    queryFn: () => listUsers({ limit: 20, offset: 0 })
  })

  const columns: ColumnDef<{ id: string; email: string; is_active: boolean }>[] = [
    { accessorKey: 'email', header: 'Email' },
    { accessorKey: 'is_active', header: 'Active', cell: ({ getValue }) => (getValue<boolean>() ? 'Yes' : 'No') }
  ]

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Users</h1>
      <DataTable data={data?.results} columns={columns} loading={isLoading} empty="No users" />
    </div>
  )
}

